import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWest = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m15 5 7 7-7 7-1.4-1.4 4.575-4.6H2v-2h16.175l-4.6-4.6z" })
});
export default SvgWest;
